import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill ? props.fill : "#111"}
      fillRule="evenodd"
      d="M7.667 8.645 4.62 5.465a.875.875 0 0 0-1.264 1.21l3.705 3.868a.84.84 0 0 0 .606.262.84.84 0 0 0 .606-.262l3.706-3.868a.875.875 0 1 0-1.264-1.21l-3.048 3.18Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
